import React, { useState } from 'react';
import ExchangeQuestions from './QuestionList';


const TemplateListing = () => { 
  return (
    <div>
     <ExchangeQuestions title={"template"} />
    </div>
  );
};

export default TemplateListing;
